(function() {
    'use strict';

    angular
        .module('jotApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20,
            'itemsPerPageChoose':[10,20,50,100]
        });
})();
